import { Cirus } from "@/classes/Http";

class UpdateUserInstanceBody {
    name: string;
    description: string;
    mobile: string;
    phone: string;
    email: string;
    logo_id: string;
    state_id?: number;
    city_id?: number;
    address?: string;
    country_id?: number = 103;
    // category: string;
}
export function UpdateUserInstance(instance_id: number, params: UpdateUserInstanceBody) {
    const path = `/instance/${instance_id}/update`;
    return Cirus.post(path, params);
}